import {
    HttpResponse,
    ShiftTypeModel,
    QueryModel,
    RequestParams,
    ShiftTypeModelIEnumerableApiResultSuccess,
    ShiftTypeModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class ShiftTypesDataService implements CrudService<ShiftTypeModel, ShiftTypeModel> {
    getAll(query: CrudDataQuery<ShiftTypeModel>): Promise<CrudEnumerableResponse<ShiftTypeModel>> {
        return ApiService.api.getShiftTypeBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ShiftTypeModel>): Promise<CrudEnumerableResponse<ShiftTypeModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShiftTypeModel>> {
        return ApiService.api.getShiftTypeById(id, params);
    }

    create(item: ShiftTypeModel, params?: RequestParams): Promise<CrudResponse<ShiftTypeModel>> {
        return ApiService.api.insertShiftType(item, params);
    }

    update(item: ShiftTypeModel, params?: RequestParams): Promise<ShiftTypeModel> {
        return ApiService.api.updateShiftType(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShiftTypeModel> {
        return ApiService.api.patchShiftType(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ShiftTypeModel>): Promise<CrudEnumerableResponse<ShiftTypeModel>> {
        return ApiService.api.deleteShiftTypes(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationShiftType(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ShiftTypeModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ShiftTypeModel, params?: RequestParams): Promise<CrudResponse<ShiftTypeModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShiftTypeGroupped(query, params);
    }

}
